export const SPACING = {
  SMALL: '4px',
  MEDIUM: '10px',
} as const

export const COLUMN_LAYOUTS = {
  THREE_COLUMNS: 3,
  FOUR_COLUMNS: 4,
} as const
